module.exports = __webpack_public_path__ + "img/ad-detail-icon.18fb1b83.svg";